// components/GlobalSpinner.tsx
import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";

const GlobalSpinner: React.FC = () => {
  return (
    <Backdrop
      open={true}
      sx={{ color: "#1976d2", zIndex: (theme) => theme.zIndex.modal + 1 }}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default GlobalSpinner;
